export const notificationMixin = {
  data() {
    return {
      success: null,
      error: null
    };
  },
  created() {},
  watch: {
    error() {
      setTimeout((ctx = this) => {
        ctx.error = null;
      }, 8000);
    },

    success() {
      setTimeout((ctx = this) => {
        ctx.success = null;
      }, 8000);
    }
  },
  methods: {}
};



// WEBPACK FOOTER //
// ./src/plugins/notificationMixin.js